export const CLOSE_NEW_DATASET_DIALOG = '/CLOSE/NEW_DATASET_DIALOG'

export const closeNewDatasetDialog = ()      => ({type: CLOSE_NEW_DATASET_DIALOG})

export default (state = { }, action) => {
    switch(action.type) {
        default:
            return state;
    }
}